// TODO: remove this after we have new Menu on every page
import {onUnmounted, onUpdated, ref} from '@vue/composition-api';

export function useScrollObserver() {
  const root = ref<Element>(null);
  const anchor = ref<Element>(null);
  const isHeaderSmall = ref(false);
  let observer: IntersectionObserver | null = null;

  onUpdated(() => {
    if (observer) {
      return;
    }
    if (!root.value || !anchor.value) {
      return;
    }
    observer = new IntersectionObserver(
      (entries) => {
        isHeaderSmall.value = !entries.reduce((res, x) => res && x.isIntersecting, true);
      },
      {
        root: root.value,
        threshold: 1,
      },
    );
    observer.observe(anchor.value);
  });

  onUnmounted(() => {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  });

  return {
    isHeaderSmall,
    anchor,
    root,
  };
}
